
<div class="points__card-container">
  <app-transport-list-card 
    [style.top.px]="topPositionTransportList"
    [transportList]="transportList()"
    [maxHeight]="marginTop"
    [isOverflow]="isTransportListOverflow()"
    [pointTitle]="title()"
    [previousPointTitle]="previousPointTitle()"
    [indexCard]="indexCard()"
    [status]="status()" 
    [isEndLocationCard]="isLocationCard()"
  />
  
  <article 
    #card
    [class]="'points__card' + ' ' + status()"
    [attr.data-is-location-card]="isLocationCard()"
    (click)="handleClickPoint(id())"
  >
  
    <app-header 
      [indexCard]="indexCard()"
      [title]="title()"
      [img]="img()"
      [durationMinutes]="durationMinutes()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
    
    <app-main
      [title]="title()"
      [startDate]="getStartDate()"
      [durationMinutes]="durationMinutes()"
      [isLocationCard]="isLocationCard()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
  </article>
</div>
